<template>
  <el-container class="page-x" direction="vertical">
    <el-tabs v-model="searchBox.reportStatus" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, idx) in tabList"
        :key="idx"
        :label="item.label"
        :name="item.id"
      >
      </el-tab-pane>
    </el-tabs>
    <div class="search-x">
      <div class="search-item">
        <span class="label">用户信息</span>
        <el-input
          class="input-box"
          clearable
          v-model.trim="searchBox.keyword"
          placeholder="用户ID、姓名、手机号、证件号"
        ></el-input>
      </div>
      <div class="search-item">
        <span class="label">报告上传时间</span>
        <el-date-picker
          v-model="uploadDateCache"
          type="date"
          value-format="timestamp"
          @change="toChangeTime"
          placeholder="请选择"
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
          }"
        >
        </el-date-picker>
      </div>
      <div class="search-item">
        <span class="label">印刷号</span>
        <el-input
          class="input-box"
          clearable
          v-model.trim="searchBox.likePrintNo"
          placeholder="请输入"
        ></el-input>
      </div>
      <!--添加权限码-->
      <!--v-auth="'sw_operate_log_index'"-->
      <el-button v-auth="'sa_exam_check_page'" type="primary" @click="toSearch"
        >查询</el-button
      >
      <el-button
        v-auth="'sa_item_page'"
        type="primary"
        @click="() => ($root.showPage = false)"
        >重置</el-button
      >
    </div>

    <div class="table-x" :key="searchBox.reportStatus" ref="tableBox">
      <el-table
        v-loading="loading"
        :data="tableData"
        :height="tableHeight"
        border
        class="mb20"
      >
        <el-table-column type="index" align="center" label="序号" width="80px">
        </el-table-column>

        <el-table-column prop="userId" align="center" label="用户ID">
        </el-table-column>

        <el-table-column prop="name" align="center" label="用户姓名">
        </el-table-column>

        <el-table-column prop="mobile" align="center" label="手机号">
        </el-table-column>

        <el-table-column
          prop="cardNo"
          v-if="searchBox.reportStatus == 1"
          align="center"
          label="证件号码"
        >
        </el-table-column>

        <el-table-column prop="printNo" align="center" label="印刷号">
        </el-table-column>

        <el-table-column prop="createTime" align="center" label="报告上传时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormat("Y-m-d H:i:s") }}
          </template>
        </el-table-column>

        <el-table-column
          prop="receiveTime"
          v-if="searchBox.reportStatus == 2"
          align="center"
          label="领取时间"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.source == 1"
              >{{ scope.row.receiveTime | dateFormat("Y-m-d H:i:s") }}
            </span>
            <span v-else></span>
          </template>
        </el-table-column>

        <el-table-column
          prop="updateTime"
          v-if="searchBox.reportStatus == 3"
          align="center"
          label="审核完成时间"
        >
          <template slot-scope="scope">
            {{ scope.row.updateTime | dateFormat("Y-m-d H:i:s") }}
          </template>
        </el-table-column>

        <el-table-column
          prop="reportSourceName"
          align="center"
          label="报告来源"
        >
        </el-table-column>
        <el-table-column prop="source" align="center" label="体检来源">
          <template slot-scope="scope">
            <span>{{ scope.row.source | filterValue(physicalSource) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="errorMessage"
          v-if="searchBox.reportStatus == 2"
          align="center"
          label="错误提示"
        >
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="searchBox.pageNo"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100]"
        :page-size="searchBox.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </div>
  </el-container>
</template>
<script>
const _physicalSource = [
  { label: "核保体检", value: 1 },
  { label: "健康体检", value: 2 },
  { label: "手动上传", value: 3 },
  { label: "官微", value: 4 },
  { label: "企微", value: 5 },
];
import { dateFormat } from "@/assets/js/until.js";
export default {
  data() {
    return {
      loading: false,
      // 查询条件
      searchBox: {
        pageNo: 1,
        pageSize: 10,
        keyword: "", // 用户信息
        likePrintNo: "", // 印刷号
        uploadDate: "", // 上传日期
        reportStatus: "1",
      },
      uploadDateCache: "", // 上传日期
      tableData: [],
      tableHeight: 0,
      total: 0,

      tabList: [
        { id: "1", label: "待领取" },
        { id: "2", label: "待审核" },
        { id: "3", label: "已审核" },
      ],
      physicalSource: _physicalSource,
    };
  },
  filters: {
    filterReportSource(value) {
      let reportObj = {
        AIKANG: "爱康",
        MJK: "其他",
      };
      return reportObj[value] || "";
    },
    filterValue(text, data) {
      return (
        data.find((item) => {
          if (text == item.value) {
            return item;
          }
        })?.label || text
      );
    },
  },
  created() {
    // 面包导航
    this.$root.breadList = [
      { name: "体检报告", link: "" },
      { name: "体检报告审核", link: "" },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.$refs.tableBox.offsetHeight;
      this.getData();
    });
  },
  methods: {
    toChangeTime(val) {
      console.log(val);
      if (val) {
        this.searchBox.uploadDate = dateFormat(val);
      } else {
        this.searchBox.uploadDate = "";
      }
    },
    /* tab change */
    handleClick() {
      this.searchBox.pageSize = 10;
      this.searchBox.pageNo = 1;
      this.getData();
    },
    /* 查询按钮 操作 */
    toSearch() {
      this.searchBox.pageNo = 1;
      this.getData();
    },
    /* 获取 table 列表 */
    getData() {
      this.loading = true;
      this.axios
        .get(this.getApiUrl("checkPage"), {
          params: this.searchBox,
        })
        .then((res) => {
          this.loading = false;
          if (res.code === 1) {
            this.tableData = res.data.data || [];
            this.total = res.data.total;
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    handleCurrentChange(val) {
      this.searchBox.pageNo = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.searchBox.pageNo = 1;
      this.searchBox.pageSize = val;
      this.getData();
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped></style>
